import { isAfter, addMinutes } from 'date-fns';
import { FeConstants } from 'constants/FeConstants';
import { Token } from 'crono-fe-common/types/token';
import LinkedinUrlUtils from 'crono-fe-common/utils/LinkedinUrlUtils';
import CronoError from 'crono-fe-common/types/error';
import { StrategyWithAnalytics } from 'crono-fe-common/types/strategy';
import { UserSubscription } from 'hooks/services/subscription/useGetUsers';
import { User } from 'crono-fe-common/types/user';
import Role from 'crono-fe-common/types/enums/role';

export function checkIfValidPhone(phone: string): boolean {
  const regex = FeConstants.phoneRegex;
  return regex.test(phone);
}

export function checkIfValidLinkedinProfileUrl(url: string): boolean {
  let parsed = LinkedinUrlUtils.getIdFromLinkedinProfileUrl(url);
  if (parsed) return true;

  parsed = LinkedinUrlUtils.getLeadIdFromSalesNavLeadUrl(url);
  if (parsed) return true;

  return false;
}

export function checkIfValidLinkedinCompanyUrl(url: string): boolean {
  const parsed = LinkedinUrlUtils.getIdFromLinkedinCompanyUrl(url);
  return parsed[0] !== null;
}

export function checkIfValidEmail(email: string): boolean {
  const regex = FeConstants.emailRegex;
  return regex.test(email);
}

export function isTokenValid(token: Token) {
  return isAfter(new Date(token.validTo), new Date());
}

export function isTokenRefreshable(token: Token) {
  return isAfter(new Date(token.validTo), addMinutes(new Date(), 5));
}

export const hasBase64ImageTag = (text: string): boolean => {
  const base64ImageRegex =
    /<img[^>]+src=["']data:image\/(png|jpeg|jpg|gif);base64,[^"']+["'][^>]*>/i;

  return base64ImageRegex.test(text);
};

export function isCronoError(error: unknown): error is CronoError {
  if (typeof error !== 'object' || error == null) return false;
  if (!('message' in error) || !error.message) return false;
  if (!('response' in error)) return false;

  const { response } = error;

  if (typeof response !== 'object' || response == null) return false;
  if (!('data' in response)) return false;

  const { data } = response;

  if (typeof data !== 'object' || data == null) return false;
  if (!('errors' in data) || data.errors == null) return false;

  return true;
}

export const getSequencePickedNotAllowedTooltip = (
  user: User | null | undefined,
  selectedStrategy: StrategyWithAnalytics | undefined,
  selectedUser: Pick<UserSubscription, 'id'> | null,
): string | null => {
  if (!user || !selectedStrategy || !selectedUser) {
    return null;
  }

  //A manager acts on behalf of the owner, and the API validates the sequence
  //visibility for that owner, so a private sequence is not blocked here
  if (user.userRoles.includes(Role.MANAGER)) {
    return null;
  }

  if (!selectedStrategy.shared && selectedUser.id !== user.id) {
    return 'You are not allowed to choose a private sequence when importing to another user';
  }

  return null;
};
